import { render, staticRenderFns } from "./buktiPotongPajak.vue?vue&type=template&id=6657416c&scoped=true&"
import script from "./buktiPotongPajak.vue?vue&type=script&lang=js&"
export * from "./buktiPotongPajak.vue?vue&type=script&lang=js&"
import style0 from "./buktiPotongPajak.vue?vue&type=style&index=0&id=6657416c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6657416c",
  null
  
)

export default component.exports